import { render, staticRenderFns } from "./buying-order-step4.vue?vue&type=template&id=8b2f0678&"
import script from "./buying-order-step4.vue?vue&type=script&lang=js&"
export * from "./buying-order-step4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports